// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimate = objectOf({
  window: string,
  count: anyOf(number, nullOrUndefined),
  precision: anyOf(enumOf("EXACT", "AT_LEAST"), nullOrUndefined),
  estimated_duration_seconds: anyOf(number, nullOrUndefined),
});

export const isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimatesResult = objectOf({
  orders: arrayOf(isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimate),
  customers: arrayOf(isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimate),
});
